/**
 * Clean artifact filename by removing dataset storage prefixes
 */
export const cleanArtifactFilename = (filename: string): string => {
    return filename.replace(/dataset_files\/dataset_id_\d+_/, "");
};